export default "__VITE_ASSET__jujOF6Sv__"